// The Whole Story – hero morph (Figma Smart Animate between the framed and expanded variants).
// Sets --p (0 → 1) on <twst-hero>; all geometry is interpolated in CSS.
// Modes: scroll (pinned, follows scroll), auto (plays after a delay), start / end (static).
if (!customElements.get('twst-hero')) {
  const clamp = (v) => Math.min(1, Math.max(0, v));
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2); // ease-in-out (cubic)

  customElements.define(
    'twst-hero',
    class TwstHero extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode;
        this.stage = this.querySelector('.twst-hero__stage');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || this.mode === 'start') return this.set(0);
        if (this.mode === 'end') return this.set(1);

        if (this.mode === 'auto') {
          this.set(0);
          const io = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            setTimeout(() => this.play(Number(this.dataset.duration) || 1600), Number(this.dataset.delay) || 0);
          });
          io.observe(this);
          return;
        }

        // scroll mode: progress = how far the pinned stage has travelled through the section
        this.current = 0;
        this.target = 0;
        this.loop = this.loop.bind(this);
        this.onScroll = () => {
          this.target = this.measure();
          if (!this.frame) this.frame = requestAnimationFrame(this.loop);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.current = this.target = this.measure();
        this.set(ease(this.current));
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        cancelAnimationFrame(this.frame);
      }

      measure() {
        const rect = this.getBoundingClientRect();
        const travel = rect.height - this.stage.offsetHeight;
        if (travel <= 0) return 0;
        return clamp(-rect.top / travel);
      }

      // smooth the scroll value a little so the morph feels like Smart Animate, not jumpy
      loop() {
        this.current += (this.target - this.current) * 0.18;
        if (Math.abs(this.target - this.current) < 0.001) this.current = this.target;
        this.set(ease(this.current));
        this.frame = this.current === this.target ? null : requestAnimationFrame(this.loop);
      }

      play(duration) {
        const start = performance.now();
        const step = (now) => {
          const t = clamp((now - start) / duration);
          this.set(ease(t));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }

      set(p) {
        this.style.setProperty('--p', p.toFixed(4));
      }
    }
  );
}
